import styled, {css} from "styled-components"
import {Col as Column} from "@irati/ui/src/ColumnRow"
import {H2 as Header2} from "@irati/ui/src/Typography"

export const Container = styled.div`
  ${({theme}) => css`
    margin: ${theme.spacing.four};
    ${theme.mediaQueries.maxWidthMedia.tablet`
      margin: 0;
    `}
  `}
`

export const Col = styled(Column)`
  padding-left: 0 !important;
  padding-right: 0 !important;
`

export const H2 = styled(Header2)`
  ${({theme}) => css`
    margin-left: ${theme.spacing.two};
    margin-bottom: ${theme.spacing.four};
    ${theme.mediaQueries.maxWidthMedia.tablet`
      margin-left: 0;
      margin-top: ${theme.spacing.two};
    `}
  `}
`
